import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { DisplayBox } from "../components";
import { ApiHelper, DateHelper, SupportTicketInterface, UserHelper, ToastHelper } from "../helpers";
import { TicketDetails } from "./components/TicketDetails";


interface Props {

}


export const SupportPage: React.FC<Props> = props => {

  const [tickets, setTickets] = React.useState<SupportTicketInterface[]>(null);
  const [selectedTicket, setSelectedTicket] = React.useState<SupportTicketInterface>(null);




  const getRows = () => {
    const result: React.ReactElement[] = [];
    tickets?.forEach(t => {
      const ticket = t;
      result.push(<tr>
        <td><a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedTicket(ticket) }}>{t.id}</a></td>
        <td>
          {DateHelper.getDisplayDuration(DateHelper.convertToDate(t.lastUpdated))}
        </td>
      </tr>)
    })
    if (result.length > 0) return result;
    else return <p>No tickets have been submitted yet. Click the +New button to submit a ticket.</p>
  }

  const init = () => {
    ApiHelper.get<SupportTicketInterface[]>("/supportTickets")
      .then((data) => setTickets(data || []))
      .catch(err => {
        console.error("Failed to load support tickets:", err);
        ToastHelper.error("Failed to load support tickets");
      });
    setSelectedTicket(null);
  }

  React.useEffect(init, [])

  const addTicket = (e: React.MouseEvent) => {
    e.preventDefault();
    setSelectedTicket({ accountId: UserHelper.currentDepartment.accountId, departmentId: UserHelper.currentDepartment.id })
  }

  const getNewButton = () => {
    return <Button size="sm" variant="success" onClick={addTicket} ><i className="fas fa-comments" style={{ color: "#FFF" }}></i> New</Button>
  }

  const getDetails = () => {
    if (selectedTicket) return <TicketDetails ticket={selectedTicket} onDone={init} />
  }

  return (
    <>
      <h1><i className="fas fa-comments"></i> Support</h1>
      <p>For help with common questions, please visit our <a href="http://support.signpresenter.com/">support wiki</a>.</p>
      <Row>
        <Col sm={6}>
          <DisplayBox headerIcon="fas fa-comments" headerText="Support Tickets" editContent={getNewButton()} >
            <table className="table table-sm">
              <tr><th>Ticket #</th><th>Last Updated</th></tr>
              {getRows()}
            </table>
          </DisplayBox>
        </Col>
        <Col sm={6}>
          {getDetails()}

        </Col>
      </Row>
    </>
  );
};